module.exports = __webpack_public_path__ + "static/media/02.cac7479e.png";